(function () {
	'use strict';

	var module = angular.module('uwAgenda.global');
	/* picker to select a timerange */
	module.directive('timerangePicker', ['$timeout', 'HelperService',
		function ($timeout, HelperService) {

			var directive = {
				link: link,
				restrict: 'E',
				replace: true,
				templateUrl: '/app/global/templates/rf-global-timerange-picker.template.html',
				scope: {
					from: '=',
					to: '=',
					isRequired: '=?', //default: false
					onTimeChangeFn: '&?', //is called on any time-change
					allowOvernight: '=?' //is it allowed to set overnight times (8am to next day 8am)
				}
			};
			return directive;

			function link(scope, element, attrs) {
				var isCheckingRange = false;
				var isInternalFromUpdate = false;
				var isInternalToUpdate = false;

				// use vm-variables because of different date formats for view and backend
				scope.vmFrom = null;
				scope.vmTo = null;

				activate();

				// watcher for changes from parent scope
				var watchUnbinderOvernight = scope.$watch(function () {
					return scope.allowOvernight;
				}, function (newVal) {
					// when overnight is not allowed, check the timerange and update the times if needed
					if (newVal === false) {
						// set param 'calledFromvmFrom' to true so that the enddate will be corrected if needed
						checkRange(true);
					}
				});

				// watcher for changes from parent scope
				var watchUnbinderFrom = scope.$watch(function () {
					return scope.from;
				}, function (newVal) {
					// if parameter has been set on a timepicker-change, the vm-variable should not be set again
					if (!isInternalFromUpdate) {
						scope.vmFrom = convertToDateObject(newVal);
						adjustDateParts();
					}
					else {
						isInternalFromUpdate = false;
					}
				});

				// watcher for changes from parent scope
				var watchUnbinderTo = scope.$watch(function () {
					return scope.to;
				}, function (newVal) {
					// if parameter has been set on a timepicker-change, the vm-variable should not be set again
					if (!isInternalToUpdate) {
						scope.vmTo = convertToDateObject(newVal);
						adjustDateParts();
					}
					else {
						isInternalToUpdate = false;
					}
				});

				// destroy watcher
				scope.$on('$destroy', function () {
					watchUnbinderFrom();
					watchUnbinderFrom = null;
					watchUnbinderTo();
					watchUnbinderTo = null;
				});

				// time in timepicker has changed
				scope.fromChanged = function () {
					isInternalFromUpdate = true;
					// convert string to date object
					scope.vmFrom = convertToDateObject(scope.vmFrom);
					checkRange(true);
					// set parameter to correct time format and call event
					scope.from = convertToBackendDate(scope.vmFrom);

					if (scope.onTimeChangeFn) {
						scope.onTimeChangeFn({ from: scope.from, to: scope.to });
					}
				};

				// time in timepicker has changed
				scope.toChanged = function () {
					isInternalToUpdate = true;
					// convert string to date object
					scope.vmTo = convertToDateObject(scope.vmTo);
					checkRange(false);
					// set parameter to correct time format and call event
					scope.to = convertToBackendDate(scope.vmTo);

					if (scope.onTimeChangeFn) {
						scope.onTimeChangeFn({ from: scope.from, to: scope.to });
					}
				};

				function activate() {
					scope.allowOvernight = scope.allowOvernight ? true : false;

					// convert time to correct format for view
					scope.vmFrom = convertToDateObject(scope.from);
					scope.vmTo = convertToDateObject(scope.to);
					adjustDateParts();
				}

				/* sets date-part of the vm-time variables to the same date for correct comparison */
				function adjustDateParts() {
					if (scope.vmFrom && scope.vmTo) {
						scope.vmTo.setDate(scope.vmFrom.getDate());
						scope.vmTo.setMonth(scope.vmFrom.getMonth());
						scope.vmTo.setYear(scope.vmFrom.getYear());
					}
				}

				/* makes sure, the value is a date object */
				function convertToDateObject(value) {
					if (!value) {
						return null;
					}
					var result = moment(value).toDate();
					return result;
				}

				/* converts the time to the correct format for the backend */
				function convertToBackendDate(time) {
					if (!time) {
						return null;
					}
					var result = HelperService.backendDate(time);
					return result;
				}

				/* sets the from- or to-time to the other one if the timerange is invalid */
				function checkRange(calledFromvmFrom) {
					if (!isCheckingRange) {
						isCheckingRange = true;
						if (scope.vmFrom && scope.vmTo) {
							if (!scope.allowOvernight) {
								//if (moment(scope.vmTo) > moment(scope.vmTo).hour(23).minute(59).second(59).millisecond(0))
								var duration = moment.duration(moment(scope.vmTo) - moment(scope.vmFrom)).asMinutes();
								if (duration < 0) {
									// add/substract one hour to make sure, that the times are different, otherwise it would count as an overnight time-range
									if (calledFromvmFrom) {
										scope.vmTo = moment(scope.vmFrom).add(1, 'h').toDate();
									}
									else {
										scope.vmFrom = moment(scope.vmTo).subtract(1, 'h').toDate();
									}
								}
							}
						}
						isCheckingRange = false;
					}
				}
			}
		}]);
})();